module.exports = __webpack_public_path__ + "img/arrow-right-button.e7ddf3d3.svg";